import env, {envType} from "../config/index";


let api = {};

// WHITE ELEPHANT - change this to the actual links
switch (env) {
    case envType.DEV:
        api.main = 'https://isoapistaging.gotspare.com/';
        break;
    case envType.PROD:
        api.main = 'https://isoapi.gotspare.com/';
        break;
    case envType.LOCAL:
    default:
        api.main = 'http://vatmisoportalapi.timdev/';
        break;
}

export default api;